import { http } from './request';
import type { LifecycleStatus, LifecycleEvent, CancelAccountRequest } from '../types/lifecycle';
import type { ApiResponse } from '../types/api';

// 生命周期相关 API
export const lifecycleApi = {
  // 获取生命周期状态
  getStatus: () =>
    http.get<LifecycleStatus>('/api/v1/tenant/lifecycle/status'),

  // 获取生命周期事件列表
  getEvents: (page = 1, pageSize = 10) =>
    http.get<{ items: LifecycleEvent[]; total: number }>('/api/v1/tenant/lifecycle/events', {
      page,
      page_size: pageSize,
    }),

  // 发起账户注销
  cancelAccount: (reason: string) =>
    http.post<{ success: boolean }>('/api/v1/tenant/lifecycle/cancel', {
      reason,
    } as CancelAccountRequest),

  // 恢复账户（冷静期内）
  reactivateAccount: () =>
    http.post<{ success: boolean }>('/api/v1/tenant/lifecycle/reactivate'),
};

export default lifecycleApi;
